import { updateBuyFundNotesForFund } from '../buy/buy-fund-notes-utility';
import {
  BUY_TRANSACTION,
  EXCHANGE_TRANSACTION,
  FundNoteAutoBuy,
  FundNoteBuy,
  SELL_TRANSACTION,
  SystemCode,
} from 'src/settings/settings';
import {
  checkFoundFeaturesByCode,
  DISABLE_ON_MATCH,
  hasZeroBalance,
  isTransactionRestrictedForFundingBank,
  updateFundNote,
} from '../shared/shared-fund-notes-utility';
import { isIRA } from '../../IRA/IRA-utility';
import { isIRAAutoMax } from '../../transactions-util';

const requiredFeatures = {
  CHECK_REDEMPTION: 'Check Redemption',
  EXCHANGE: 'Exchange',
};

/**
 * Creates function for looking up recurring specific server codes
 * @param {UserFund} fund
 * @param {Number} serviceCode
 * @returns {boolean}
 */
function checkFoundFeaturesByCodeForRecurring(fund, serviceCode) {
  return checkFoundFeaturesByCode(fund, serviceCode, true);
}

export function updateRecurringBuyFundNotesForFund(
  fund,
  personalData,
  data,
  selectedBankAgreementMap,
  hasAutoMax
) {
  updateBuyFundNotesForFund(fund, personalData, data, selectedBankAgreementMap);

  // If client has a closed fund with zero balance
  // agreementType is not COLLEGE_SAVINGS
  updateFundNote(
    fund,
    hasZeroBalance(fund) &&
      fund.agreementType !== 'COLLEGE_SAVINGS' &&
      fund.productType !== 'ManagedAccount',
    FundNoteAutoBuy.CLOSED_FUND,
    DISABLE_ON_MATCH
  );

  updateFundNote(
    fund,
    fund.recurringTransactionTypes.indexOf(BUY_TRANSACTION) >= 0 ||
      checkFoundFeaturesByCodeForRecurring(
        fund,
        SystemCode.SYSTEMATIC_PURCHASE_TO_ACCOUNT
      ),
    FundNoteAutoBuy.AUTO_BUY,
    DISABLE_ON_MATCH
  );

  updateFundNote(
    fund,
    fund.recurringTransactionTypes.indexOf(EXCHANGE_TRANSACTION) >= 0 &&
      fund.agreementType !== 'COLLEGE_SAVINGS',
    FundNoteAutoBuy.AUTO_EXCHANGE
  );

  updateFundNote(
    fund,
    fund.recurringTransactionTypes.indexOf(SELL_TRANSACTION) >= 0 &&
      fund.agreementType !== 'COLLEGE_SAVINGS',
    FundNoteAutoBuy.AUTO_SELL,
    DISABLE_ON_MATCH
  );

  updateFundNote(
    fund,
    isIRA(fund) && hasAutoMax,
    FundNoteAutoBuy.IRA_AUTOMAX,
    DISABLE_ON_MATCH
  );

  // Transaction Pending
  updateFundNote(fund, fund.hasPendingTransaction, FundNoteAutoBuy.PENDING);

  // return E_Mail
  updateFundNote(
    fund,
    checkFoundFeaturesByCodeForRecurring(
      fund,
      SystemCode.RETURN_E_MAIL_VERIFY_ADDRESS
    ),
    FundNoteAutoBuy.RETURN_E_MAIL_VERIFY_ADDRESS
  );

  updateFundNote(
    fund,
    checkFoundFeaturesByCodeForRecurring(fund, SystemCode.STOP_PURCHASE),
    FundNoteAutoBuy.STOP_PURCHASE,
    DISABLE_ON_MATCH
  );

  // If fund is not restricted for client's current  bank selection, and the selected
  // bank cannot be associated with the fund, add BANK_NOT_ASSOCIATED fund note.
  updateFundNote(
    fund,
    !isTransactionRestrictedForFundingBank(fund, selectedBankAgreementMap) &&
      fund.bankAssociable,
    FundNoteAutoBuy.BANK_NOT_LINKED,
    DISABLE_ON_MATCH
  );
}

export function updatIRAAutoMaxFundNotesForFund(
  fund,
  personalData,
  data,
  selectedBankAgreementMap,
  hasAutoMax
) {
  updateBuyFundNotesForFund(fund, personalData, data, selectedBankAgreementMap);

  // If client has a closed fund with zero balance
  // agreementType is not COLLEGE_SAVINGS
  updateFundNote(
    fund,
    hasZeroBalance(fund) &&
      fund.agreementType !== 'COLLEGE_SAVINGS' &&
      fund.productType !== 'ManagedAccount',
    FundNoteAutoBuy.CLOSED_FUND,
    DISABLE_ON_MATCH
  );

  // Transaction Pending
  updateFundNote(fund, fund.hasPendingTransaction, FundNoteAutoBuy.PENDING);

  // return E_Mail
  updateFundNote(
    fund,
    checkFoundFeaturesByCodeForRecurring(
      fund,
      SystemCode.RETURN_E_MAIL_VERIFY_ADDRESS
    ),
    FundNoteAutoBuy.RETURN_E_MAIL_VERIFY_ADDRESS
  );

  updateFundNote(
    fund,
    checkFoundFeaturesByCodeForRecurring(fund, SystemCode.STOP_PURCHASE),
    FundNoteAutoBuy.STOP_PURCHASE,
    DISABLE_ON_MATCH
  );

  // If fund is not restricted for client's current  bank selection, and the selected
  // bank cannot be associated with the fund, add BANK_NOT_ASSOCIATED fund note.
  updateFundNote(
    fund,
    !isTransactionRestrictedForFundingBank(fund, selectedBankAgreementMap) &&
      fund.bankAssociable,
    FundNoteAutoBuy.BANK_NOT_LINKED,
    DISABLE_ON_MATCH
  );

  const missingFeatures =
    fund?.fundLock?.missingRequiredFeatures?.map(({ code }) => code) || [];

  const restrictOnlinePurchase = [
    requiredFeatures.CHECK_REDEMPTION,
    requiredFeatures.EXCHANGE,
  ].every((feature) => missingFeatures.includes(feature));

  updateFundNote(
    fund,
    restrictOnlinePurchase && isIRAAutoMax(),
    FundNoteBuy.ONLINE_PURCHASE_RESTRICTED,
    DISABLE_ON_MATCH
  );
}
